import { useEffect, useState } from "react";

import { getErrorMessage, isAPIError } from "@/core/services";
import {
  HISTORICO_DETALHE_ERROR_MESSAGE,
  HISTORICO_FORBIDDEN_MESSAGE,
} from "@/modules/recursos/simulacao";
import { buscarDetalheSimulacao } from "@/modules/recursos/simulacao.gateway";
import type { SimulacaoDetalheApi } from "@/modules/recursos/simulacao.gateway";

export type DetalheStatus = "loading" | "success" | "error" | "forbidden";

export interface UseDetalheSimulacaoResult {
  status: DetalheStatus;
  detalhe: SimulacaoDetalheApi | null;
  errorMessage: string | null;
  reload: () => void;
}

/** GET /simulacoes/{id}: o registro completo com o relatório reconstruído (histórico, RF07). */
export function useDetalheSimulacao(simulacaoId: string): UseDetalheSimulacaoResult {
  const [status, setStatus] = useState<DetalheStatus>("loading");
  const [detalhe, setDetalhe] = useState<SimulacaoDetalheApi | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    setStatus("loading");
    setErrorMessage(null);

    buscarDetalheSimulacao(simulacaoId, controller.signal)
      .then((registro) => {
        if (cancelled) return;
        setDetalhe(registro);
        setStatus("success");
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        const forbidden = isAPIError(error) && error.status === 403;
        setStatus(forbidden ? "forbidden" : "error");
        setDetalhe(null);
        setErrorMessage(
          forbidden
            ? HISTORICO_FORBIDDEN_MESSAGE
            : getErrorMessage(error) || HISTORICO_DETALHE_ERROR_MESSAGE,
        );
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [simulacaoId, reloadToken]);

  function reload() {
    setReloadToken((token) => token + 1);
  }

  return { status, detalhe, errorMessage, reload };
}
